import React, { useState, useEffect  } from 'react';
import './SecretCodeDialog.css';

const SecretCodeDialog = ({ show, onVerify }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!code || code.length < 6) {
      setError('Please enter a valid code');
      return;
    }
    onVerify(code);
  };
    useEffect(() => {
        if (show) {
        document.body.style.overflow = 'hidden';
        } else {
        document.body.style.overflow = 'auto';
        }
        return () => {
        document.body.style.overflow = 'auto';
        };
    }, [show]);

  if (!show) return null;

  return (
    <>
      <div className="dialog-backdrop"></div>
      <div className="dialog-container">
        <div className="dialog-box">
          <h2>Two-Factor Authentication</h2>
          <p>Please enter the secret code sent to your email</p>
          
          <form onSubmit={handleSubmit}>
            <div className="code-input">
              <input
                type="text"
                value={code}
                onChange={(e) => {
                    setCode(e.target.value)
                    setError('');
                }}
                placeholder="Enter the secret code"
                autoFocus
                maxLength={20}
              />
            </div>
            
            {error && <p className="error-message">{error}</p>}
            
            <div className="dialog-actions">
              <button disabled={!code} className="primary" onClick={handleSubmit}>
                Verify
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SecretCodeDialog;